import { useQuery } from '@tanstack/react-query';
import { unwrap } from '@billda/api';
import { api } from '../../../shared/api/billdaApi';
import { sitesKeys } from './useSites';
import { useAuthStore } from '../../auth/stores/authStore';

/**
 * Hook to fetch a single site's details via v2 API.
 */
export function useSiteDetails(siteId: number | null) {
  const isAuthenticated = useAuthStore(state => state.isAuthenticated);

  const { data, error, isFetching } = useQuery({
    queryKey: sitesKeys.detail(siteId || 0),
    queryFn: async ({ signal }) =>
      unwrap(
        await api.legacy.GET('/api/v2/sites/{id}', {
          params: {
            path: { id: siteId! },
            query: { includePlots: false },
          },
          signal,
        })
      ),
    placeholderData: previousData => previousData,
    enabled: isAuthenticated && !!siteId,
    staleTime: 30000,
  });

  return { data, error, isFetching };
}
